import { useEffect as useEffectOriginal } from 'react';
import { logUiErrorToBackend } from './logUiErrorToBackend';

// Re-export useEffect for components that need it
export { useEffect } from 'react';

/*
 * useEffectWithErrorLogging
 * Wraps a useEffectWithErrorLogging callback with error logging for both sync and async errors.
 */

export function useEffectWithErrorLogging(effect, deps, context) {
	useEffectOriginal(() => {
		try {
			const result = effect();
			if (result && typeof result.then === 'function') {
				result.catch((err) => {
					logUiErrorToBackend(err, context || 'useEffectWithErrorLogging async error');
				});
			}
			return result;
		} catch (err) {
			logUiErrorToBackend(err, context || 'useEffectWithErrorLogging sync error');
		}
	}, deps);
}
